import { Injectable, inject } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { LendingTypeService } from '@shared/services/lending-type.service';
import { AffordabilityFormFieldsBtlService } from './affordability-form-fields-btl.service';
import { AffordabilityFormFieldsResiService } from './affordability-form-fields-resi.service';

@Injectable({
  providedIn: 'root',
})
export class AffordabilityFormFieldsService {
  private readonly resiFields = inject(AffordabilityFormFieldsResiService);
  private readonly btlFields = inject(AffordabilityFormFieldsBtlService);
  public readonly lendingTypeService = inject(LendingTypeService);

  public get fields(): FormlyFieldConfig[] {
    if (!this.lendingTypeService.currentLendingTypeCode) {
      return [];
    }
    switch (this.lendingTypeService.currentLendingTypeCode) {
      case 'BTL':
        return this.btlFields.fields;
      case 'RES':
        return this.resiFields.fields;
      default:
        throw new Error(`No products question set configured for lending type '${this.lendingTypeService.currentLendingTypeCode}'`);
    }
  }

  public getStepFields(): FormlyFieldConfig[] {
    return this.fields ?? [];
  }
}
